<template>
  <div class="pricing_item top40" :class="{ active: season.active }">
    <div class="pricebox bottom25 clearfix">
      <div class="price_title">
        <h3 class="darkcolor text-uppercase bottom10">{{ season.name }}</h3>
      </div>
      <div class="price darkcolor" v-if="season.price != null && season.price !== ''">
        <p>ab<strong>{{ season.price }},00€*</strong><span class="month">/Tag</span></p>
      </div>
    </div>
    <p class="availability" v-if="hasDisplayText(season.date)">
      <strong v-html="season.date"></strong>
    </p>
    <p class="availability" v-if="hasDisplayText(season.subline1)" v-html="season.subline1"></p>
    <p class="availability" v-if="hasDisplayText(season.subline2)" v-html="season.subline2"></p>
    <p class="availability" v-if="hasDisplayText(season.text)"><strong v-html="season.text"></strong></p>
    <p v-if="season.showContact" class="pricing_item__contact">
      <a href="#contact_us" class="button light scroll">Kontakt</a>
    </p>
  </div>
</template>

<script>
import { hasDisplayText } from '../../lib/helper.js'

export default {
  props: {
    season: {
      type: Object,
      required: true
    }
  },
  setup() {
    return { hasDisplayText }
  }
}
</script>

<style scoped lang="scss">
.pricing_item__contact {
  margin-top: auto;
  padding-top: 0.75rem;
  text-align: center;

  .button.light {
    display: inline-block;
    width: auto;
    min-width: 10rem;
  }
}

@media (max-width: 767px) {
  .pricing_item__contact {
    padding-top: 1rem;

    .button.light {
      display: block;
      width: 100%;
      max-width: none;
      text-align: center;
      font-size: 1rem;
      padding: 0.875rem 1.5rem;
    }
  }
}
</style>
